var slider = document.getElementById('age-slider');

var min_age = parseInt($('#min-age').val());
var max_age = parseInt($('#max-age').val());

var selected_age_min = parseInt($('#selected-min-age').val());
var selected_age_max = parseInt($('#selected-max-age').val());

noUiSlider.create(slider, {
  step: 1,
  start: [selected_age_min, selected_age_max],
  // start: [23, 33],
  connect: true,
  range: {
    'min': min_age,
    'max': max_age
  },
  tooltips: true,
  pips: {
    mode: 'range',
    density: 10
  },
  format: wNumb({
    decimals: 0
  })
});

function updateAgeFields(values) {
  $("#selected-min-age").val(values[0]);
  $("#selected-max-age").val(values[1]);
  submitForm()
}
slider.noUiSlider.on('change', updateAgeFields)

$('#sort_by, #job_opening_id').on('change', function () {
  submitForm()
})

function submitForm() {
  $('#applicant_form').trigger('submit')
}
